export default __webpack_public_path__ + "static/media/RejectIcon.3446220e.svg";